import moment from 'moment'

import { longDateShortMonthTime } from 'utils'

export const CreationDate: TAnt.TableColumnRender<string> = (createdAt) => (
  <>{moment(createdAt).format(longDateShortMonthTime).toLowerCase()}</>
)
